import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 1200 1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--stroke-0, white)",
      "stroke-opacity": ".2",
      d: "M0 .5h1200"
    }, null, -1)
  ]))]))
}
export default { render: render }